import _asyncToGenerator from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
import _regeneratorRuntime from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import Modal from "../Modal";
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useModalOpened, useModalToggle } from "../../state/application/hooks";
import { ApplicationModal } from "../../state/application/reducer";
import { Agreement } from "../Agreement";
import { NetworkConnectOptions } from "./Components/NetworkConnectOptions";
import { useCallback } from 'react';
import { useConnectionOptions } from "../../hooks/useConnectionOptions";
import { ConnectLabel, StyledConnectOptions, StyledOption } from "./Components/StyledOptions";
import ArrowRight from "../../assets/images/right.png";
import { useAppDispatch } from "../../state/hooks";
import { updatePendingChainId, updateSelectedConnectionType } from "../../state/user/actions";
import { usePendingChainId } from "../../state/user/hooks";
var StyledAgreementContent = styled.div.withConfig({
  displayName: "StyledAgreementContent",
  componentId: "sc-vczf63-0"
})(["margin:2rem 0;"]);

var ConnectionOptions = function ConnectionOptions() {
  var options = useConnectionOptions();

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var dispatch = useAppDispatch();
  var toggleModal = useModalToggle(ApplicationModal.WALLET_CONNECT);
  var pendingChainId = usePendingChainId();
  var tryActivate = useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(option) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              if (!option.activate) {
                _context.next = 6;
                break;
              }

              _context.next = 4;
              return option.activate(option.connector, dispatch, pendingChainId);

            case 4:
              _context.next = 8;
              break;

            case 6:
              _context.next = 8;
              return option.connector.activate(pendingChainId);

            case 8:
              dispatch(updateSelectedConnectionType(option.type));
              toggleModal();
              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](0);
              console.error('Failed to activate connector', _context.t0);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 12]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [dispatch, pendingChainId]);
  return __jsx(StyledConnectOptions, {
    className: "connect-options"
  }, __jsx(ConnectLabel, null, " 2.", t('select_wallet'), " "), options.map(function (option) {
    return __jsx(StyledOption, {
      key: option.type,
      onClick: function onClick() {
        return tryActivate(option);
      }
    }, __jsx("img", {
      src: option.icon,
      alt: option.name,
      className: "logo"
    }), option.name, __jsx("img", {
      src: ArrowRight.src,
      alt: "",
      className: "indicator"
    }));
  }));
};

var ConnectWithAgreement = function ConnectWithAgreement() {
  var _useTranslation2 = useTranslation(),
      t = _useTranslation2.t;

  var pendingChainId = usePendingChainId();
  var dispatch = useAppDispatch();

  var onPendingChainIdSelect = function onPendingChainIdSelect(chainId) {
    dispatch(updatePendingChainId(chainId));
  };

  return __jsx(React.Fragment, null, __jsx(Agreement, null), __jsx("div", {
    className: "content"
  }, __jsx(StyledAgreementContent, null, __jsx(NetworkConnectOptions, {
    label: "1. ".concat(t('select_network')),
    chainId: pendingChainId,
    onSelect: onPendingChainIdSelect
  }), __jsx(ConnectionOptions, null))));
};

export var WalletModal = function WalletModal() {
  var isOpen = useModalOpened(ApplicationModal.WALLET_CONNECT);
  var toggleModal = useModalToggle(ApplicationModal.WALLET_CONNECT);

  var _useTranslation3 = useTranslation(),
      t = _useTranslation3.t;

  return __jsx(Modal, {
    title: t('connect'),
    isOpen: isOpen,
    onDismiss: toggleModal
  }, __jsx(ConnectWithAgreement, null));
};
export default WalletModal;